// extracted by mini-css-extract-plugin
export var barContainer = "_2d-0";
export var extraThin = "_2d-3";
export var fillBar = "_2d-6";
export var fillContainer = "_2d-4";
export var overflow = "_2d-8";
export var overflowContainer = "_2d-5";
export var regular = "_2d-7";
export var thick = "_2d-1";
export var thin = "_2d-2";